window.themeToggleNav = function() {
  var nav = document.getElementById('site-nav');
  if (!nav) return;
  if (getComputedStyle(nav).display === 'none') {
    nav.style.display = 'flex';
  } else {
    nav.style.display = 'none';
  }
};

function formatMoney(cents) {
  var value = (cents / 100);
  try {
    return value.toLocaleString('fr-FR', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  } catch (e) {
    return value.toFixed(2) + ' €';
  }
}

// ---- Dynamic variant pricing ----
window.themeInitProduct = function () {
  var jsonEl = document.getElementById('ProductJson');
  if (!jsonEl) return;

  var product = JSON.parse(jsonEl.textContent);
  var optionSelects = document.querySelectorAll('.product-option-select');
  var priceEl = document.getElementById('ProductPrice');
  var variantPriceEl = document.getElementById('VariantPrice');
  var compareEl = document.getElementById('ProductCompareAt');
  var addToCartBtn = document.getElementById('AddToCartButton');
  var imgEl = document.getElementById('ProductImage');

  function getSelectedVariant() {
    if (!product || !product.variants) return null;
    var selectedOptions = [];
    optionSelects.forEach(function (select) {
      selectedOptions.push(select.value);
    });
    return product.variants.find(function (variant) {
      if (!variant.options) return false;
      for (var i = 0; i < variant.options.length; i++) {
        if (variant.options[i] !== selectedOptions[i]) return false;
      }
      return true;
    });
  }

  function updateUI(variant) {
    if (!variant) return;
    var formatted = formatMoney(variant.price);
    if (priceEl) priceEl.textContent = formatted;
    if (variantPriceEl) variantPriceEl.textContent = formatted;
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.style.display = '';
        compareEl.textContent = formatMoney(variant.compare_at_price);
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Ajouter au panier';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Rupture de stock';
      }
    }
    if (imgEl && variant.featured_image && variant.featured_image.src) {
      imgEl.src = variant.featured_image.src;
    }
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      var variant = getSelectedVariant();
      updateUI(variant);
    });
  });

  var initial = getSelectedVariant();
  if (initial) updateUI(initial);
};

// ---- Favorites using localStorage ----
var FAVORITES_KEY = 'solarys_favorites';

function getFavorites() {
  try {
    var raw = localStorage.getItem(FAVORITES_KEY);
    if (!raw) return [];
    return JSON.parse(raw);
  } catch (e) {
    return [];
  }
}

function saveFavorites(list) {
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(list));
  } catch (e) {}
}

function toggleFavorite(handle) {
  var favs = getFavorites();
  var index = favs.indexOf(handle);
  if (index === -1) favs.push(handle);
  else favs.splice(index, 1);
  saveFavorites(favs);
  return favs.indexOf(handle) !== -1;
}

window.themeInitFavoritesButtons = function () {
  var buttons = document.querySelectorAll('[data-favorite-toggle]');
  if (!buttons.length) return;
  var favs = getFavorites();

  buttons.forEach(function (btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    function refresh() {
      if (favs.indexOf(handle) !== -1) btn.textContent = 'Retirer des favoris';
      else btn.textContent = 'Ajouter aux favoris';
    }

    refresh();

    btn.addEventListener('click', function () {
      toggleFavorite(handle);
      favs = getFavorites();
      refresh();
    });
  });
};

// ---- Favorites page ----
window.themeInitFavoritesPage = function () {
  var grid = document.getElementById('FavoritesGrid');
  var emptyEl = document.getElementById('FavoritesEmpty');
  if (!grid || !emptyEl) return;

  var favs = getFavorites();
  if (!favs.length) {
    emptyEl.style.display = 'block';
    return;
  }
  emptyEl.style.display = 'none';

  favs.forEach(function (handle) {
    var url = '/products/' + handle + '.js';
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var card = document.createElement('article');
        card.className = 'card-product';
        var link = document.createElement('a');
        link.href = product.url;

        if (product.featured_image) {
          var img = document.createElement('img');
          img.src = product.featured_image;
          img.alt = product.title;
          link.appendChild(img);
        }

        var title = document.createElement('h2');
        title.textContent = product.title;
        link.appendChild(title);

        var priceP = document.createElement('p');
        priceP.className = 'price';
        priceP.textContent = formatMoney(product.price);
        link.appendChild(priceP);

        card.appendChild(link);
        grid.appendChild(card);
      })
      .catch(function (e) {
        console.error('Erreur chargement favori', handle, e);
      });
  });
};

// ---- PWA: service worker + banner ----
function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('{{ "service-worker.js" | asset_url }}').catch(function (e) {
      console.warn('SW registration failed', e);
    });
  }
}

var deferredPrompt = null;

function initPWABanner() {
  var banner = document.getElementById('pwa-banner');
  var btn = document.getElementById('pwa-install-btn');
  var closeBtn = document.getElementById('pwa-close-btn');
  if (!banner || !btn || !closeBtn) return;

  var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (!isMobile) return;

  var isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  if (isStandalone) return;

  banner.style.display = 'block';

  btn.addEventListener('click', function () {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.finally(function () {
        banner.style.display = 'none';
      });
    } else {
      alert('Pour ajouter Solarys Market :\n\n- Sur Android : menu ⋮ → Ajouter à l\'écran d\'accueil\n- Sur iPhone : bouton partager ⬆️ → Sur l\'écran d\'accueil');
    }
  });

  closeBtn.addEventListener('click', function () {
    banner.style.display = 'none';
  });

  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    deferredPrompt = e;
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('ProductJson')) {
    window.themeInitProduct();
    window.themeInitFavoritesButtons();
  }
  if (document.getElementById('FavoritesGrid')) {
    window.themeInitFavoritesPage();
  }
  registerServiceWorker();
  initPWABanner();
});
